import {isMobile} from 'react-device-detect';

const SHOWED_UPSELLING_DEALS_MODAL = 'showed_upselling_deals_modal';

const RESERVATION_ID_KEY = 'chekin-reservation-id';
const HOUSING_ID_KEY = 'chekin-housing-id';
const HOST_ID_KEY = 'chekin-host-user-id';
const LAYOUT_MODE_KEY = 'chekin-layout';
const MAIN_TOKEN_ID_KEY = 'main-token';
const PREVIOUS_PAGE_STORAGE_KEY = 'chekin-previous-page';
const SIGNATURES_QUALITY = 0.8;
const SHOWED_GUEST_GROUP_MODAL = 'showed_guest_group_modal';
const SHOWED_SUCCESS_REGISTER_COMPLETE_MODAL =
  'showed_success_register_complete_complete';
const SHOWED_SUCCESS_CHECKOUT_COMPLETE_MODAL =
  'showed_success_checkout_complete_complete';
const IS_LEADER_GUEST_STORAGE_KEY = 'is_leader_guest';

enum STORAGE_KEYS {
  personalFormData = 'PERSONAL_FORM_DATA',
  personalSignatureFormData = 'PERSONAL_SIGNATURE_FORM_DATA',
  ivIntentRemoteSession = 'IV_INTENT_REMOTE_SESSION',
}

enum STATUSES {
  loading = 'loading',
  error = 'error',
  success = 'success',
  idle = 'idle',
}

const WHATSAPP_SHARE_LINK = isMobile
  ? 'whatsapp://send/'
  : 'https://api.whatsapp.com/send';
const SMS_SHARE_LINK = 'sms://';
const EMAIL_SHARE_LINK = 'mailto:%20';

export {
  RESERVATION_ID_KEY,
  MAIN_TOKEN_ID_KEY,
  STORAGE_KEYS,
  SIGNATURES_QUALITY,
  STATUSES,
  WHATSAPP_SHARE_LINK,
  SMS_SHARE_LINK,
  EMAIL_SHARE_LINK,
  SHOWED_GUEST_GROUP_MODAL,
  SHOWED_SUCCESS_REGISTER_COMPLETE_MODAL,
  SHOWED_SUCCESS_CHECKOUT_COMPLETE_MODAL,
  HOUSING_ID_KEY,
  HOST_ID_KEY,
  PREVIOUS_PAGE_STORAGE_KEY,
  IS_LEADER_GUEST_STORAGE_KEY,
  SHOWED_UPSELLING_DEALS_MODAL,
  LAYOUT_MODE_KEY,
};
